import { motion, useInView } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';

function AnimatedNumber({ value, prefix = '', suffix = '', inView }) {
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) {
      setDisplay(0);
      return;
    }

    const duration = 2000;
    const startTime = performance.now();

    function tick(now) {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      // ease-out cubic
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplay(Math.round(eased * value));
      if (progress < 1) {
        requestAnimationFrame(tick);
      }
    }

    requestAnimationFrame(tick);
  }, [inView, value]);

  return (
    <span>
      {prefix}{display}{suffix}
    </span>
  );
}

const stats = [
  { value: 12, prefix: '$', suffix: 'K', label: 'Total Prize Pool' },
  { value: 17, prefix: '', suffix: '', label: 'Award Categories' },
  { value: 500, prefix: '$', suffix: '', label: 'Minimum Cash Prize' },
  { value: 4, prefix: '', suffix: '', label: 'Days of Screenings' },
];

export default function StatsStrip() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-50px' });

  return (
    <motion.section
      ref={ref}
      className="bg-dark2 border-y"
      style={{ borderColor: 'rgba(255,255,255,0.06)' }}
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      <div className="max-w-[1200px] mx-auto px-6 py-10 grid grid-cols-2 md:grid-cols-4">
        {stats.map((stat, i) => (
          <div
            key={stat.label}
            className={`flex flex-col items-center justify-center py-6 md:py-0 ${
              i < stats.length - 1 ? 'md:border-r' : ''
            } ${i < 2 ? 'border-b md:border-b-0' : ''}`}
            style={{ borderColor: 'rgba(255,255,255,0.06)' }}
          >
            <span
              className="font-display gradient-text leading-none"
              style={{ fontSize: '3.5rem' }}
            >
              <AnimatedNumber
                value={stat.value}
                prefix={stat.prefix}
                suffix={stat.suffix}
                inView={inView}
              />
            </span>
            <span
              className="text-muted uppercase mt-2"
              style={{
                fontSize: '0.72rem',
                letterSpacing: '0.15em',
              }}
            >
              {stat.label}
            </span>
          </div>
        ))}
      </div>
    </motion.section>
  );
}
